export default {
      id: "menu__statistic-usage",
      viewBox: "0 0 36 36",
      url: __webpack_public_path__ + "img/icons.svg#menu__statistic",
      toString: function () {
        return this.url;
      }
    }